import { Img } from "@/components/ui/img";
import { LogoMark } from "@/components/Logo";

// The brand byline used for all editorial / migrated posts. When the author is
// the brand itself we show the real Psihotron logo mark instead of a generic
// letter circle, so the byline reads as the brand and fits the rest of the UI.
const BRAND_AUTHOR = "psihotron";

interface AuthorAvatarProps {
  name?: string | null;
  image?: string | null;
  /** Rendered size in px (matches the old size-6/9/10/14 circles: 24/36/40/56). */
  size?: number;
  className?: string;
}

export function AuthorAvatar({ name, image, size = 24, className }: AuthorAvatarProps) {
  const dim = { width: size, height: size };

  if (image) {
    return (
      <Img
        src={image}
        alt={name ?? ""}
        style={dim}
        className={`shrink-0 rounded-full object-cover ${className ?? ""}`}
      />
    );
  }

  // Brand byline: static logo mark, no surrounding circle.
  if ((name ?? "").trim().toLowerCase() === BRAND_AUTHOR) {
    return (
      <LogoMark
        animate={false}
        title={name ?? "Psihotron"}
        style={dim}
        className={`shrink-0 ${className ?? ""}`}
      />
    );
  }

  // Human author without a photo: refined gradient initial.
  return (
    <div
      style={{
        ...dim,
        fontSize: Math.round(size * 0.42),
        background: "linear-gradient(135deg, oklch(74% 0.11 84), oklch(58% 0.14 70))",
      }}
      className={`flex shrink-0 items-center justify-center rounded-full font-bold text-white ${className ?? ""}`}
      aria-hidden="true"
    >
      {(name ?? "?").charAt(0).toUpperCase()}
    </div>
  );
}
